//This component will show  popup for filter

import { connect } from "react-redux";
import React from "react";
import reqwest from "reqwest";
import {
  activateDatadic,
  activateFiname,
  activateRecord,
  activateScreen,
  activateStocks,
  activateLoadid,
  activateChange,
  activateShowfilter,
  activateSaveFilter,
  activatePageswitch,
  activateSavedes,
  activateAfters,
  activateRecordtb,
  activateScreenList,
  activateUnivid,
  activateUnivname,
  activateUnivtype,
} from "../redux";
import {
  Button,
  Modal,
  Typography,
  Menu,
  Dropdown,
  message,
  Space,
  Select,
  Divider,
} from "antd";
import { DownOutlined, UserOutlined ,ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";
import SaveFilterO from "./SaveFilterOnly";
const { Title } = Typography;
const { Option, OptGroup } = Select;
const { confirm } = Modal;
class ScreenMenuClass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      isModalVisible: true,
      setIsModalVisible: true,
    };

    this.HandleReqNow = this.HandleReqNow.bind(this);
    this.handleChangeGet = this.handleChangeGet.bind(this);
    this.hidecancel = this.hidecancel.bind(this);
    this.afterSave = this.afterSave.bind(this);
    
    //this.openNewScreen = this.openNewScreen.bind(this);
    
   // this.getall = this.getall.bind(this);
 
    if (this.props.finame == "") {
      this.props.activateFiname("Untitled New Screen");
    }
    
  }

  openNewScreen() {
 
    if (this.props.finame == "Manage My Saved Screens") {
      this.props.activateFiname("");
      this.props.activateShowfilter(1);
      this.props.history.push("/");
     }
      this.FilterMount();
      this.props.activateFiname("Untitled New Screen");
      this.props.showModal();
      
      
}

  showConfirm() {
    confirm({
      title: 'Would you like to save your screen?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      cancelText: 'No',
      content: ' ',
      onOk:() => {
        this.setState({
          showsavefilteronly: true,
          
        })
        this.props.activateAfters({va1:-2,va2:-2})
      },
      onCancel:() => {
        this.props.activateChange('');
        this.openNewScreen(1);
        this.fetchwithname();
      },
    });
  }

  showConfirmSwitchScreen(v1,v2) {
    confirm({
      title: 'Would you like to save your screen?',
      icon: <ExclamationCircleOutlined />,
      content: ' ',
      onOk:() => {
        this.setState({
          showsavefilteronly: true,
      
        })
        this.props.activateAfters({va1:v1,va2:v2})
      },
      onCancel:() => {
        this.props.activateChange('');
        this.HandleReqNow(v1,v2);
        if (this.props.finame == "Manage My Saved Screens") {
          this.props.history.push("/");
        }
      },
    });
  }
  
  
  componentDidMount() {
    this.setState({
      loading: true,
    });
    reqwest({
      url:
        this.props.apppath +
        "/include/api/screener/Simsaveload.cfm?uid=" +
        this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {
      this.setState({
        data: data.results,
        loading: false,
      });

      this.props.activateSaveFilter(data.results); 
     
    });



    

///////////////////////////////

reqwest({
  url:
    this.props.apppath +
    "/include/api/myportfolio/loadportscreen.cfm?uid=" +
    this.props.auid,
  method: "get",
  type: "json",
}).then((data2) => {
 
  this.setState({
    datascreen: data2.results,
    loading: false,
  });

  this.props.activateScreenList(data2); 

});






  }

  FilterMount() {
    this.setState({ loading: true });
    reqwest({
      url:
        this.props.apppath + "/include/api/screener/stockScreenerFilter.json",
      //url:'jlast.json',
      method: "get",
      type: "json",
    }).then((data) => {
      this.props.activateDatadic({ FilterDic: data.tables[0] });
      //this.props.activateDatadicbackup({ FilterDic: data.tables[0] });
      
    });
  }














  addToPortfilter(name,id) {

    this.setState({
      lookingTickers: true,
      runscreen: true,
      loading: true,
    });

    
    this.props.activateUnivid(id);
    this.props.activateUnivname('AAII Screen: '+name);
    this.props.activateUnivtype(2);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tables: [this.props.datadic.FilterDic], screenId: id
      }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen: false,
            count: 60,
            loadmod:false,
            loading: true,
            visible: true,
          },
          () => {

            this.props.activateScreen(false);
            this.props.activateRecord(data.filteredData.length);
            this.props.activateRecordtb(data.filteredData.length);

            this.setState({ count: 100 });
            this.props.activateStocks(data.filteredData);
            // this.props.activateChange('');
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
        this.setState(
          {
            lookingTickers: false,
            
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
          }
        );
      });


  }


  handleChangeGet(value) {
    console.log(`selected ${value}`);
    
    if (value[1] == -4) {
       console.log('111111111111')
       this.props.activateFiname(value[0]);
       this.addToPortfilter(value[0],value[2])
    } else if (value[1] == -2) {
    
                   if (this.props.change=='') {
                    this.fetchwithname();
                      if (this.props.finame == "Manage My Saved Screens") {
                        this.props.activateFiname("");
                        this.props.activateShowfilter(1);
                        this.props.history.push("/");
                      
                        
                      }
                        this.FilterMount();
                        this.props.activateFiname("Untitled New Screen");
                        this.props.showModal();
                    }else {
                      this.showConfirm(-2);
                    }

    } else if (value[1] == -3) {
                this.props.activatePageswitch(this.props.finame);
                this.props.activateFiname("Manage My Saved Screens");
                this.props.activateShowfilter('');
                this.props.history.push("/managecreen");
    } else if (value[1] == -1) {
    } else {
       
     if (this.props.change=='') {
      
              this.HandleReqNow(value[2], value[1]);
              if (this.props.finame == "Manage My Saved Screens") {
              
                this.props.history.push("/");
              }
    }else {
      
      this.showConfirmSwitchScreen(value[2], value[1]);
    }

    }

  
  }


  afterSave() {
    var  id=this.props.afters; 
    this.setState({
      showsavefilteronly: false,
   
    }, () => {
     
  });

  if (id.va1==-2){
    this.props.activateChange('');
    this.FilterMount();
    this.fetchwithname();
    this.props.activateFiname("Untitled New Screen");
   
    
       this.props.showModal();
     }
     if (id.va1!=-2){
      
       //alert('sfsfs')
       this.props.activateChange('');
       this.HandleReqNow(id.va1,id.va2);
    //  alert('screen')
     }
}


fetchwithname = (params = {}) => {
  this.setState({ loading: true });
  reqwest({
    url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
    method: "get",
    type: "json",
 
  }).then((data) => {
    this.props.activateStocks(data.screenRating);
    this.props.activateRecordtb(data.screenRating.length);
    this.props.activateRecord(data.screenRating.length);
    
    this.setState({
      loading: false,
    
    });
  });
};



  HandleReqNow(id, rid = 0) {
     console.log('TESTTEST',this.props.savefilter[id])
    this.setState({
      lookingTickers: true,
      runscreen: true,
    });
    this.props.activateScreen(true);
    this.setState({
      count: 40,
    });
    this.props.activateDatadic({
      FilterDic: JSON.parse(this.props.savefilter[id].FILTER_),
    });
    this.props.activateFiname(this.props.savefilter[id].NAME_);

    this.props.activateLoadid(rid);
    this.props.activateSavedes({name:this.props.savefilter[id].NAME_,des:this.props.savefilter[id].description_});
    //alert(rid)
 
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tables: [JSON.parse(this.props.savefilter[id].FILTER_)],
      }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen: false,
            count: 60,
          },
          () => {
           
            this.props.activateScreen(false);
            this.props.activateRecord(data.filteredData.length);
            this.props.activateRecordtb(data.filteredData.length);
           
            this.setState({ count: 100 });
            this.props.activateStocks(data.filteredData);
            // this.props.activateChange('');
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
          }
        );
      });

      
  }
    hidecancel = () => {
  
    this.setState({
      showsavefilteronly: false,
      showsaveFornewScreen: false,
    });
  };


 

  render() {
    const endSafe = () => {
      
      this.setState({
        showsavefilteronly: false,
    
      }, () => {
       
    });
    };


   
    
  

 
    return (
      <div>
          <SaveFilterO isModalsave={this.state.showsavefilteronly}  aftersave={this.afterSave} justclosenow={endSafe} hidecancel={this.hidecancel}></SaveFilterO>
        {this.props.savefilter != undefined  && this.props.screenlist !=undefined ? (
          <Select
       
            style={{ width: 240 }}
            onChange={this.handleChangeGet}
            value={this.props.finame}>
          >
          <OptGroup label={<Divider>My Screens</Divider>} > 
              <Option value={[this.props.finame, -1]}  >
                {" "}
                <em>{this.props.finame}</em>
              </Option>
            

            <Option
              style={{ color: "rgb(57, 93, 173)", fontWeight: 700 }}
              value={["Create New Screen", -2, ""]}
            >
              {" "}
              Create New Screen
            </Option>
            <Option
              style={{ color: "rgb(57, 93, 173)", fontWeight: 700 }}
              value={["Manage My Saved Screens", -3, ""]}
            >
              {" "}
              Manage My Saved Screens
            </Option>
            {this.props.savefilter.map((item, i) => (
              <Option
                {...(this.props.finame == item.NAME_  || this.props.finame=='Untitled New Screen'? "selected" : "")}
                value={[item.NAME_, item.id, i]}
              >
                {item.NAME_}
              </Option>
            ))}
  </OptGroup>  
 { this.props.screenlist !=undefined ?
      <OptGroup    label={<Divider>AAII Stock Ideas</Divider>}>
        
      {this.props.screenlist.map((item, i) => (
              <Option
               
                value={[item.name, -4,item.id]}
              >
                {item.name}
              </Option>
            ))}
          
     
      </OptGroup>     :''   } 
          </Select>
        ) : (
          "Loading...."
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  auid: state.auid,
  finame: state.finame,
  screen: state.screen,
  loadid: state.loadid,
  change: state.change,
  showfilter: state.showfilter,
  savefilter: state.savefilter,
  pageswitch: state.pageswitch,
  savedes: state.savedes,
  afters: state.afters,
  afterstb: state.recordtb,
  screenlist: state.screenlist,
  univid: state.univid,
  univname: state.univname,
  univtype: state.univtype,
  
});

const mapDispatchToProps = {
  activateDatadic,
  activateFiname,
  activateRecord,
  activateScreen,
  activateStocks,
  activateLoadid,
  activateChange,
  activateShowfilter,
  activateSaveFilter,
  activatePageswitch,
  activateSavedes,
  activateAfters,
  activateRecordtb,
  activateScreenList,
   activateUnivid,activateUnivname,
   activateUnivtype,
};

const ScreenMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ScreenMenuClass));

export default ScreenMenu;
